<template>
  <section>
    <el-form inline>
        <el-form-item label="关键字">
            <el-input v-model="filters.keyword" placeholder="关键字" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
            <el-select v-model="filters.enabled" multiple="">
                <el-option label="正常" value="1"></el-option>
                <el-option label="禁用" value="0"></el-option>
            </el-select>
        </el-form-item>
    </el-form>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table-bar :fixed="true" :bottom="35">    
      <el-table
        border
        :data="users"
        highlight-current-row
        v-loading="listLoading"
        @current-change="selectCurrentRow"
        style="width: 100%;"
      >
        <el-table-column type="index" width="80"></el-table-column>
        <el-table-column prop="code" label="编码" width sortable></el-table-column>
        <el-table-column prop="name" label="角色名" width sortable></el-table-column>
        <el-table-column prop="description" label="说明" width sortable></el-table-column>
        <el-table-column prop="createTime" label="创建时间" :formatter="formatCreateTime" width sortable></el-table-column>
        <!--<el-table-column prop="CreateBy" label="创建者" width="" sortable>-->
        <!--</el-table-column>-->
        <el-table-column prop="enabled" label="状态" width="200" sortable>
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.enabled  ? 'success' : 'danger'"
              disable-transitions
            >{{scope.row.enabled ? "正常":"禁用"}}</el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="150">
          <template scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="handleDel(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </el-table-bar>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
        <el-form-item label="角色编码" prop="code">
          <el-input v-model="editForm.code" auto-complete="off" maxlength="30" disabled></el-input>
        </el-form-item>
        <el-form-item label="角色名" prop="name">
          <el-input v-model="editForm.name" auto-complete="off" maxlength="30"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="enabled">
          <el-select v-model="editForm.enabled" placeholder="请选择角色状态">
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="说明" prop="description">
          <el-input v-model="editForm.description" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-form-item label="角色编码" prop="code">
          <el-input v-model="addForm.code" auto-complete="off" maxlength="30"></el-input>
        </el-form-item>
        <el-form-item label="角色名" prop="name">
          <el-input v-model="addForm.name" auto-complete="off" maxlength="30"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="enabled">
          <!-- <el-select v-model="addForm.enabled" placeholder="请选择角色状态">
            <el-option label="激活" value="true"></el-option>
            <el-option label="禁用" value="false"></el-option>
          </el-select> -->
          <el-select v-model="addForm.enabled" placeholder="请选择角色状态">
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="说明" prop="description">
          <el-input v-model="addForm.description" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--权限分配界面-->
    <el-dialog title="分配菜单/按钮权限" :visible.sync="assignFormVisible" v-model="assignFormVisible" :close-on-click-modal="false">
      <el-card>
        <div slot="header" class="clearfix">
          <div>
            <h4>当前角色：{{currentRow?currentRow.name:''}}</h4>
          </div>
          <div class="buttons">
            <el-button size="mini" @click="setAllChecked">全选</el-button>
            <el-button size="mini" @click="resetChecked">清空</el-button>
            <el-button size="mini" @click="expandAll">展开全部</el-button>
            <el-button size="mini" @click="foldAll">折叠全部</el-button>
          </div>
        </div>
        <el-tree
          :data="treeData"
          show-checkbox
          :default-expand-all=false
          node-key="value"
          ref="tree"
          highlight-current
          :props="defaultProps">
        </el-tree>
      </el-card>
      <!-- <el-divider></el-divider> -->
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="assignFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="assignSubmit" :loading="assignLoading">提交</el-button>
      </div>
      
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getRoleListPage, removeRole, editRole, addRole, getPermissionTree, getPermissionIds, addRolePermission } from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      filters: {
        keyword: "",
        enabled: "",
      },
      buttonList: [],
      users: [],
      statusList: [
        { name: "正常", value: true },
        { name: "禁用", value: false }
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        name: [
          { required: true, message: "请输入角色名", trigger: "blur" },
          { max: 30, message: "最多输入30个字符", trigger: "blur" },
        ],
        code: [
          { required: true, message: "请输入角色编码", trigger: "blur" },
          { max: 30, message: "最多输入30个字符", trigger: "blur" },
        ],
        enabled: [{ required: true, message: "请选择状态", trigger: "blur" }],
        description: [
          { max: 50, message: "最多输入50个字符", trigger: "blur"}
        ]
      },
      //编辑界面数据
      editForm: {
        id: 0,
        name: "",
        code: "",
        enabled: false
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        name: [
          { required: true, message: "请输入角色名", trigger: "blur" },
          { max: 30, message: "最多输入30个字符", trigger: "blur" },
        ],
        code: [
          { required: true, message: "请输入角色编码", trigger: "blur" },
          { max: 30, message: "最多输入30个字符", trigger: "blur" },
        ],
        enabled: [{ required: true, message: "请选择状态", trigger: "blur" }],
        description: [
          { max: 50, message: "最多输入50个字符", trigger: "blur"}
        ]
      },
      //新增界面数据
      addForm: {
        name: "",
        code: "",
        enabled: true
      },

      assignFormVisible: false,
      assignLoading: false,
      roleId: 0,
      isExpand: false,
      treeData: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        }
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      
      this[item.func].apply(this, item);
    },
    formatCreateTime: function(row, column) {
      return !row.createTime || row.createTime == ""
        ? ""
        : util.formatDate.format(new Date(row.createTime), "yyyy-MM-dd");
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getRoles();
    },
    //获取用户列表
    getRoles() {
      let _this = this;
      let para = {
        page: this.page,
        key: this.filters.keyword,
        enabled: this.filters.enabled.toString()
      };
      this.listLoading = true;
      //NProgress.start();
      getRoleListPage(para).then(res => {
        this.total = res.data.response.total;
        this.users = res.data.response.pageData;
        this.listLoading = false;

        //NProgress.done();
      });
    },
    handleEnable(){
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要启用的一行数据！",
          type: "error"
        });

        return;
      }
      if (row.enabled){
          this.$message({
              message: "当前数据为启用状态，无需启用！",
              type: "success"
          });

          return;
      }
      row.enabled = true;
      let para = Object.assign({}, row);
      editRole(para).then(res => {
        if (util.isEmt.format(res)) {
          return;
        }

        if (res.data.success) {                
          this.$message({
            message: res.data.msg,
            type: "success"
          });
          this.getRoles();
        } else {
          row.enabled = false;
          this.$message({
            message: res.data.msg,
            type: "error"
          });
        }
      });
    },
    handleStop(){
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要禁用的一行数据！",
          type: "error"
        });

        return;
      }
      if (!row.enabled){
          this.$message({
              message: "当前数据为禁用状态，无需禁用！",
              type: "success"
          });

          return;
      }
      row.enabled = false;
      let para = Object.assign({}, row);
      editRole(para).then(res => {
        if (util.isEmt.format(res)) {
          return;
        }

        if (res.data.success) {                
          this.$message({
            message: res.data.msg,
            type: "success"
          });
          this.getRoles();
        } else {
          row.enabled = true;
          this.$message({
            message: res.data.msg,
            type: "error"
          });
        }
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.id };
          removeRole(para).then(res => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }

            this.getRoles();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }

      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        createBy: "",
        name: "",
        enabled: ""
      };
    },
    //显示权限分配界面
    handleAssign() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要分配权限的一行数据！",
          type: "error"
        });

        return;
      }

      this.assignFormVisible = true;
      this.roleId = row.id
      let para = {
        pid: 0,
        needbtn: true
      };
      getPermissionTree(para).then(res => {
        this.treeData = res.data.response.children
        getPermissionIds({rid: row.id}).then(resp=>{
          console.log(resp.data.response);
          this.$refs.tree.setCheckedKeys(resp.data.response);
        });
      });
    },
    //编辑
    editSubmit: function() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            editRole(para).then(res => {

              this.editLoading = false;
              if (util.isEmt.format(res)) {
                return;
              }

              if (res.data.success) {                
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getRoles();
              } else {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function() {
      let _this = this;
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);

            var user = JSON.parse(window.localStorage.user);

            if (user && user.id > 0) {
              para.createId = user.id;
              para.createBy = user.realName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error"
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }
            addRole(para).then(res => {
              this.addLoading = false;
              if (util.isEmt.format(res)) {
                
                return;
              }
              if (res.data.success) {
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getRoles();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    //保存权限
    assignSubmit: function() {
      let _this = this;
      _this.assignLoading = true;
      let checkedList = _this.$refs.tree.getCheckedKeys(false);
      let halfCheckedList = _this.$refs.tree.getHalfCheckedKeys();
      let pids = checkedList.concat(halfCheckedList);
      let para = {pids: pids, rid: this.roleId}
      if(para.rid>0 && para.pids.length>0){
        addRolePermission(para).then(res=>{
          _this.assignLoading = false
          this.$message({
              message: res.data.msg,
              type: res.data.success?'success':'error'
          });
        });
      }else{
        this.assignLoading = false;
        this.$message({
            message: "参数错误",
            type: 'error'
        });
      }
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function() {
      this.$message({
        message: "该功能未开放",
        type: "warning"
      });
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach(element => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    },
    setAllChecked: function() {
      var _this = this
      this.$refs.tree.setCheckedNodes(_this.treeData);
    },
    resetChecked: function() {
      this.$refs.tree.setCheckedKeys([]);
    },
    expandAll: function() {
      this.setAllExpand(true)
    },
    foldAll: function() {
      this.setAllExpand(false)
    },
    setAllExpand(state){
        var nodes=this.$refs.tree.store.nodesMap
        for(var i in nodes){
            nodes[i].expanded=state;
        }
    },
  },
  mounted() {
    this.getRoles();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);
    
    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
  }
};
</script>

<style scoped>
</style>
